<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Dərmanların qiymətləri</h1>
        <p class="note">Çətin tapılan dərman preparatlarının hansı əczaxanada olması haqqında dəqiq məlumatı 153 qısa nömrəyə zəng edərək öyrənə bilərsiniz. Servis həftənin 7 günü saat 08:00 - 21:00 arası fəaliyyət göstərir.</p>
      </div>

      <div class="col-12">
        <p>Dövlət qeydiyyatına alınmış dərman vasitələrinin qiymətləri:</p>
        <input type="text" v-model="query" placeholder="Dərmanın adını yazın" @input="getPrice(query)">
      </div>

      <div class="col-12" v-if="loading">
        <div class="spinner"><div></div><div></div><div></div></div>
      </div>

      <div class="col-12" v-if="data.length > 0">
        <table>
          <thead>
            <tr>
              <th>Dərman vasitəsinin adı</th>
              <th>Qiyməti</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data">
              <td>
                <h3>{{ item.name }} <span>№ {{ item.amount }}</span></h3>
                <p>{{ item.substance }} / {{ item.dose }}</p>
                <p>{{ item.form }} / {{ item.pack }}</p>
                <p>{{ item.manufacturer }}</p>
              </td>
              <td>{{ item.price }} AZN</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script> 

  import axios from 'axios';

  export default {
    data(){
      return {
        loading: false,
        query: '',
        data: []
      }
    },
    methods: {
      getPrice: function(query){
        this.loading = true;
        axios.get('inc/med.php', {
            params: {
              query: this.query
            }
          })
          .then(response => {
            this.loading = false;
            this.data = response.data;
          })
          .catch(error => {
            this.loading = true;
            console.log(error);
          });
      }
    }
  }
</script>

<style scoped>

table thead tr th:first-child {
  text-align: left;
}
table tr td h3 {
  text-align: left;
  margin: 0.5rem 0;
}
table tr td h3 span {
  color: #666;
} 
table tr td p {
  font-size: 0.7rem;
  margin: 0;
  text-align: left;
}
@media only screen and (max-width: 768px) {
  table {
    white-space: normal;
  }
  table thead {
    display: none;
  }
  table tbody {
    display: block;
  }
  table tr {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    background: #FFF;
  }
  table td:nth-child(2) {
    font-weight: bold;
    color: #FFF;
    background: #036;
    text-align: left;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/calc/Medicine.vue